
import Vue from 'vue';
import { HeadlineLabel } from '@headlines/types/headline';
import LinkHandler from '@core/components/helpers/LinkHandler.vue';

interface Props {
  labels: HeadlineLabel[];
  paid: boolean;
  pill: boolean;
}

export default Vue.extend<unknown, unknown, unknown, Props>({
  name: 'HeadlineLabels',
  components: {
    LinkHandler,
  },
  props: {
    labels: {
      type: Array,
      required: true,
    },
    paid: {
      type: Boolean,
      default: false,
      required: false,
    },
    pill: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
});
